import { Link } from "react-router-dom";
import type { NewsItem } from "@/mocks/news";
import { formatDate, formatShortDate } from "@/utils/format";

interface NewsListItemProps {
  item: NewsItem;
  showImage?: boolean;
  compact?: boolean;
}

export default function NewsListItem({ item, showImage = true, compact = false }: NewsListItemProps) {
  const date = formatShortDate(item.publishDate);

  return (
    <Link
      to={`/detail/news/${item.id}`}
      className={`group flex gap-4 ${compact ? "py-3" : "py-4"} border-b border-background-200 last:border-0 cursor-pointer`}
    >
      <div className="hidden sm:flex flex-col items-center justify-center shrink-0 w-14 pt-0.5">
        <span className="font-heading text-lg font-extrabold text-primary-600 leading-none">
          {date.day}
        </span>
        <span className="mt-1 text-[11px] text-foreground-500">
          {date.year}.{date.month.replace("月", "")}
        </span>
      </div>

      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 mb-1.5">
          <span className="inline-flex items-center px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-900 text-[11px] font-medium">
            {item.category}
          </span>
          <span className="sm:hidden text-[11px] text-foreground-500">{formatDate(item.publishDate)}</span>
        </div>
        <h3
          className={`font-bold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-2 ${
            compact ? "text-[14px] leading-6" : "text-[15px] md:text-base leading-7"
          }`}
        >
          {item.title}
        </h3>
        {!compact && (
          <p className="mt-1.5 text-[13px] leading-relaxed text-foreground-600 line-clamp-2">
            {item.summary}
          </p>
        )}
        {!compact && (
          <div className="mt-2 flex items-center gap-3 text-[11px] text-foreground-500">
            <span>{item.author}</span>
            <span className="w-1 h-1 rounded-full bg-background-300" />
            <span>约 {Math.max(2, Math.round(item.content.join("").length / 300))} 分钟阅读</span>
          </div>
        )}
      </div>

      {showImage && !compact && (
        <div className="hidden sm:block shrink-0 w-32 md:w-40 h-20 md:h-24 rounded-md overflow-hidden bg-background-200">
          <img
            src={item.cover}
            alt={item.title}
            title={`${item.title} - 小电影影视资讯`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
      )}
    </Link>
  );
}